export default "__VITE_ASSET__BRa2bfuL__"